import { useEffect } from "react";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";

import { useParams } from "react-router-dom";
import { LabSamplesDetailsViewModel } from "../../viewmodels/labSamples/LabSamplesDetailsViewModel";
import LabSampleDetailsForm from "../../components/forms/labSample/LabSampleDetailsForm";

function LabSampleDetails(props) {
  const { addSnackbar, logout } = props;

  const { id } = useParams();

  const {
    emptyModal,
    setEmptyModelOpen,
    loading,
    labSample,
    getLabSampleDetails,
    updateLabSample,
    inProgress,
    labs,
    getLabsForDropdown,
  } = LabSamplesDetailsViewModel(logout, id, addSnackbar);

  useEffect(() => {
    getLabSampleDetails();
    getLabsForDropdown();
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        {loading ? (
          "Loading"
        ) : (
          <LabSampleDetailsForm
            inProgress={inProgress}
            labSample={labSample}
            updateLabSample={updateLabSample}
            labs={labs}
            loading={loading}
          />
        )}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
        size={emptyModal.size}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LabSampleDetails)
);
